export enum DropIndicatorPosition {
  Inside = "inside",
  Top = "top",
  Bottom = "bottom",
  Right = "right",
  Left = "left"
}

export enum ElType {
  Page = "page",
  Panel = "panel",
  Question = "question",
  DynamicPanel = "dynamic-panel",
  EmptySurvey = "empty-survey"
}